<template lang="pug">
.container
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="sendEmail" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.detail.$invalid" :vm-active="isModalContactVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=7)
        vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            h4 Necesitas mas cantidad o no encuentras el producto? Contactanos
            p Si el producto que buscas no se encuentra en nuestras existencias no dudes en contactarnos! Nosotros haremos lo posible por conseguir el producto lo mas rapido y al mejor precio posible!
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group
              vm-input(:placeholder='$t("contact.product_placeholder")' v-model="detail.product" :label='$t("contact.product")' disabled)
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group
              vm-input(v-model="detail.quantity" autofocus :label='$t("contact.quantity")' :danger="!$v.detail.quantity.minValue || !$v.detail.quantity.required" type="number")
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            b-form-group
              vm-input(v-model="detail.full_name" autofocus :label='$t("contact.full_name")' :danger="!$v.detail.full_name.required || !$v.detail.full_name.required" :danger-text="'Nombre es requerido'" type="text")
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group
              vm-input(v-model="detail.phone" autofocus :label='$t("contact.phone")' :danger="!$v.detail.phone.maxLength || !$v.detail.phone.required" :danger-text="'Ingrese un telefono valido'" type="text")
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group
              vm-input(v-model="detail.email" autofocus :label='$t("contact.email")' :danger="!$v.detail.email.email || !$v.detail.email.required" :danger-text="'Porfavor, ingrese un correo valido'" type="text")
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            b-form-group
              vm-textarea(counter="140" label="Tu mensaje" v-model="detail.message" :danger="!$v.detail.message.maxLength || !$v.detail.message.required")
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            p.total Total: {{ this.detail.total }}
      vm-col.moy-info(vm-justify="center", vm-align="center", vm-w=5)
        img.moy-logo(src="@/assets/logo2.png")
        p <br> Calle progreso # 406 <br> Colonia Centro <br> Código postal: 31000 <br> Chihuahua, Chih., México
</template>
<script>
import { required, minValue, maxLength, email } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Pos')

export default {
  name: 'ModalContact',
  props: {
    detail: {
      type: Object
    },
    index: {
      type: Number
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations () {
    return {
      detail: {
        quantity: {
          required,
          minValue: minValue(0.01)
        },
        message: {
          maxLength: maxLength(140),
          required
        },
        email: {
          email,
          required
        },
        full_name: {
          required
        },
        phone: {
          required,
          maxLength: maxLength(16)
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalContactVisible',
      'inventoriesCatalog'
    ]),
    getTitle () {
      return 'Contactar'
    },
    maxValue () {
      return this.detail.quantity_max ? this.detail.quantity_max : 0
    }
  },
  methods: {
    ...mapActions([
      'setModalContactVisible',
      'sendContactEmail',
      'loadCatalog'
    ]),
    saveRecord () {
      // this.isAdd ? this.addPurchaseRequisitionDetail(this.detail) : this.editPurchaseRequisitionDetail({ detail: this.detail, index: this.index })
    },
    async getCatalog () {
      // Object.keys(this.purchaseRequisitionsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    sendEmail () {
      this.sendContactEmail({ detail: this.detail, id: this.index })
    },
    addDetail () {
      this.isAdd ? this.addPurchaseRequisitionDetail(this.detail) : this.editPurchaseRequisitionDetail({ detail: this.detail, index: this.index })
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=${param}*&order_by=${column},asc`
    },
    close () {
      this.setModalContactVisible(false)
    },
    setUnitPrice (value) {
      this.unit_price = value
    }
  },
  watch: {
    'detail.quantity' (quantity) {
      this.detail.total = (parseFloat(this.detail.unit_price) * parseFloat(quantity)).toFixed(2)
    }
  }
}
</script>

<style scoped>
.total {
  font-weight: bold;
  font-size: 1.2rem;
}
.moy-info {
  text-align: center;
  height: 100%;
}
.moy-logo {
  width: 40%;
}
.vm-select--options {
  z-index: 400331 !important;
}
#contact_link {
  cursor: pointer;
}
</style>
